module.exports = __webpack_public_path__ + "img/brain-mapb.fba4bcbf.png";